import { cn, ProductBadge } from '@yanolja-rnd/nol-design-system'

/**
 * Pre-Order(장바구니, 주문서, 쿠폰모달)에서 사용되는 "국내숙소" RatePlan 옵션 리스트
 * - 뱃지 스타일
 */
const DomesticPropertyRatePlanBenefits = ({ ratePlanBenefits }: { ratePlanBenefits: string[] }) => {
  return (
    <div className={cn('flex flex-wrap gap-4 break-keep')}>
      {ratePlanBenefits.map((benefit, index) => (
        <ProductBadge key={index} type="outlined_basic" size="medium" className={cn('break-keep')}>
          {benefit}
        </ProductBadge>
      ))}
    </div>
  )
}

export default DomesticPropertyRatePlanBenefits
